import { Minus, Plus, Image, Route } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import Button from '@/components/common/Button'

interface MapCanvasControlsProps {
  onZoomIn: () => void
  onZoomOut: () => void
  /** 画像全体を表示（背景画像がある場合のみ指定） */
  onFitImage?: () => void
  /** 選択パス全体を表示（選択がある場合のみ指定） */
  onFitSelected?: () => void
}

export function MapCanvasControls({
  onZoomIn,
  onZoomOut,
  onFitImage,
  onFitSelected,
}: MapCanvasControlsProps) {
  const { t } = useTranslation()

  return (
    <div className="absolute top-2 right-2 z-10 flex flex-col gap-2">
      <Button
        onClick={onZoomIn}
        variant="white"
        className="font-bold p-2 shadow"
      >
        <Plus size={16} />
      </Button>
      <Button
        onClick={onZoomOut}
        variant="white"
        className="font-bold p-2 shadow"
      >
        <Minus size={16} />
      </Button>
      {onFitImage && (
        <Button
          onClick={onFitImage}
          variant="white"
          className="text-sm p-2 shadow"
          title={t('scenarios.fitImage')}
        >
          <Image size={18} />
        </Button>
      )}
      {onFitSelected && (
        <Button
          onClick={onFitSelected}
          variant="white"
          className="text-sm p-2 shadow"
          title={t('scenarios.fitSelected')}
        >
          <Route size={18} />
        </Button>
      )}
    </div>
  )
}
